export type HeaderPageMeta = {
  title: string;
  parent?: string;
  parentPath?: string;
};

const pageMeta: Record<string, HeaderPageMeta> = {
  "/": { title: "Dashboard" },
  "/dashboard": { title: "Dashboard" },
  "/access-denied": { title: "Access Denied" },
  "/create-by-ai": { title: "Create Contract with AI", parent: "Contracts", parentPath: "/get-contracts" },
  "/property_insurance": { title: "Property Insurance", parent: "Insurance & Payments" },
  "/team_management": { title: "Team", parent: "Operations" },
  "/credit_card_precessing": { title: "Credit Card Processing", parent: "Insurance & Payments" },
  "/logan-ai-admin": { title: "Logan AI Administration" },
  "/logan-ai": { title: "Logan AI" },
  "/billing/cards-expiring-soon": { title: "Cards Expiring Soon", parent: "Billing" },
  "/billing/payment-alerts": { title: "Payment Alerts", parent: "Billing" },
  "/twilio-notifications": { title: "Twilio Notifications", parent: "Admin" },
  "/people/:id": { title: "Profile" },
  "/service-reviews": { title: "Service Reviews" },
  "/wallet": { title: "My Wallet" },
  "/free-estimates": { title: "Free Estimates", parent: "Admin" },
  "/insurance-contacts": { title: "Insurance Contacts", parent: "Admin" },
  "/mechanics-lien-intakes": { title: "Mechanics Lien Intakes" },
  "/agent-property-leads": { title: "Available Property Leads", parent: "Properties" },
  "/agent-my-property-leads": { title: "My Property Leads", parent: "Properties" },
  "/life_health_insurance": { title: "Life & Health Insurance", parent: "Insurance & Payments" },
  "/investments": { title: "Investments", parent: "Insurance & Payments" },
  "/invoices-list": { title: "Invoices" },
  "/apps-invoices-overview": { title: "Invoice Details", parent: "Invoices", parentPath: "/invoices-list" },
  "/apps-invoices-create": { title: "Create Invoice", parent: "Invoices", parentPath: "/invoices-list" },
  "/contracts-list": { title: "Contracts" },
  "/property-manager": { title: "Property Manager" },
  "/apps-contracts-overview": { title: "Contract Details", parent: "Contracts", parentPath: "/get-contracts" },
  "/apps-contracts-create": { title: "Create Contract", parent: "Contracts", parentPath: "/get-contracts" },
  "/apps-tickets-overview": { title: "Ticket Details", parent: "Support", parentPath: "/apps-tickets-list" },
  "/apps-tickets-list": { title: "Support" },
  "/apps-chat": { title: "Chat" },
  "/apps-real-estate-grid": { title: "Properties" },
  "/live-contract-details": { title: "Contract Details", parent: "Contracts", parentPath: "/live-contracts" },
  "/apps-real-estate-agent-grid-view": { title: "Agents", parent: "Properties" },
  "/apps-real-estate-agent-homeowner": { title: "Homeowner Referrals", parent: "Properties" },
  "/agent-property-recommendations": { title: "Property Recommendations", parent: "Properties" },
  "/contract-tutorial-and-plans": { title: "Contract Tutorial & Plans" },
  "/marketing": { title: "Marketing & Website Development" },
  "/create-your-team": { title: "Create Your Team", parent: "Team", parentPath: "/team_management" },
  "/apps-real-estate-property-overview": { title: "Property Details", parent: "Properties" },
  "/apps-real-estate-explore-contractor": { title: "Explore Contractors", parent: "Properties" },
  "/apps-real-estate-add-properties": { title: "Add Property", parent: "Properties" },
  "/suggested-contractors": { title: "Suggested Contractors" },
  "/recommended-properties": { title: "Recommended Properties" },
  "/pages-term-conditions": { title: "Terms & Conditions" },
  "/pages-timeline": { title: "Timeline" },
  "/pages-faqs": { title: "FAQs" },
  "/pages-contacts": { title: "Contacts" },
  "/pages-contractors": { title: "Contractors" },
  "/pages-credentials": { title: "Credentials" },
  "/pages-pricing": { title: "Pricing" },
  "/pages-profile": { title: "Profile" },
  "/profile": { title: "Profile" },
  "/pages-contracor-profile": { title: "Contractor Profile", parent: "Contractors" },
  "/pages-profile-settings": { title: "Profile Settings", parent: "Account", parentPath: "/profile" },
  "/pages-projects": { title: "Leads" },
  "/pages-user-overview": { title: "User Details", parent: "Users" },
  "/recent-contractors": { title: "Recent Contractors" },
  "/get-contracts": { title: "Contracts" },
  "/view-sub-contracts": { title: "Subcontracts", parent: "Contracts", parentPath: "/get-contracts" },
  "/live-contracts": { title: "Live Contracts", parent: "Contracts", parentPath: "/get-contracts" },
  "/messages": { title: "Messages" },
  "/leadHistory": { title: "Lead History", parent: "Leads", parentPath: "/pages-projects" },
  "/create-contract": { title: "Create Contract", parent: "Contracts", parentPath: "/get-contracts" },
  "/create-sworn-contracts": { title: "Create Sworn Contract", parent: "Contracts", parentPath: "/get-contracts" },
  "/create-sworn-homeowner": { title: "Create Homeowner Contract", parent: "Contracts", parentPath: "/get-contracts" },
  "/chat-room": { title: "Chat", parent: "Messages", parentPath: "/messages" },
  "/project-overview": { title: "Project Details", parent: "Leads", parentPath: "/pages-projects" },
  "/project-requested": { title: "Requested Leads", parent: "Leads", parentPath: "/pages-projects" },
  "/project-ongoing-leads": { title: "Accepted Leads", parent: "Leads", parentPath: "/pages-projects" },
  "/pages-all-contractors": { title: "All Contractors", parent: "Admin" },
  "/pages-all-homeowners": { title: "All Homeowners", parent: "Admin" },
  "/escrow-requests": { title: "Escrow Requests", parent: "Admin" },
  "/pages-all-leads": { title: "All Leads", parent: "Admin" },
  "/catogery-master": { title: "Category Master", parent: "Admin" },
  "/sub-catogery-master": { title: "Subcategory Master", parent: "Admin" },
  "/coupan-dashboard": { title: "Coupon Dashboard", parent: "Admin" },
  "/version-controle": { title: "Version Control", parent: "Admin" },
  "/push-notification": { title: "Push Notifications", parent: "Admin" },
  "/mls-cache-control": { title: "MLS Cache Control", parent: "Admin" },
  "/property-leads": { title: "Property Leads", parent: "Admin" },
  "/pages-single-homeowner": { title: "Homeowner Details", parent: "Homeowners", parentPath: "/pages-all-homeowners" },
  "/pages-all-real-estate-agents": { title: "Real Estate Agents", parent: "Admin" },
  "/pages-all-admins": { title: "Administrators", parent: "Admin" },
  "/platform-access": { title: "Platform Access", parent: "Admin" },
  "/pages-single-contractors": { title: "Contractor Details", parent: "Contractors", parentPath: "/pages-all-contractors" },
  "/pages-all-forms": { title: "Form Leads", parent: "Admin" },
  "/pages-all-subscribers": { title: "Subscribers", parent: "Admin" },
  "/pages-all-transactions": { title: "Transactions", parent: "Admin" },
  "/kyc-status-page": { title: "KYC Status", parent: "Merchant Enrollment" },
  "/kyc-form-page": { title: "KYC Form", parent: "Merchant Enrollment" },
};

const merchantTitles: Record<string, string> = {
  "/merchant/business-info": "Business Information",
  "/merchant/owners": "Business Owners",
  "/merchant/kyc": "Identity Verification",
  "/merchant/status": "Enrollment Status",
  "/merchant/payment-setup": "Payment Setup",
  "/merchant/payments": "Payments",
  "/merchant/payouts": "Payouts",
};

const titleFromPath = (pathname: string) =>
  pathname
    .split("/")
    .filter(Boolean)
    .pop()
    ?.replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase()) || "Dashboard";

export const getHeaderPageMeta = (pathname: string, search = "", userType = ""): HeaderPageMeta => {
  const searchParams = new URLSearchParams(search);

  if (pathname === "/wallet" && userType === "admin") {
    return { title: "Contractor Wallets", parent: "Admin" };
  }

  if (pathname === "/wallet" && searchParams.get("tab") === "referrals") {
    return { title: "Refer & Earn", parent: "My Wallet", parentPath: "/wallet" };
  }

  const leadFlowTitles: Record<string, string> = {
    "/pages-projects": "Leads",
    "/project-requested": "Requested Leads",
    "/project-ongoing-leads": "Accepted Leads",
    "/leadHistory": "Lead History",
  };

  if (leadFlowTitles[pathname] && searchParams.get("leadId")) {
    return { title: "Lead Details", parent: leadFlowTitles[pathname], parentPath: pathname };
  }

  if (pathname.startsWith("/project-details/")) {
    return { title: "Project Details", parent: "Leads", parentPath: "/pages-projects" };
  }

  if (pathname.startsWith("/people/")) return { title: "Profile" };

  if (pathname.startsWith("/recent-contractors/")) {
    if (searchParams.get("from") === "suggested-contractors") {
      return { title: "Contractor Profile", parent: "Suggested Contractors", parentPath: "/suggested-contractors" };
    }
    return { title: "Contractor Profile", parent: "Recent Contractors", parentPath: "/recent-contractors" };
  }

  if (merchantTitles[pathname]) {
    return { title: merchantTitles[pathname], parent: "Merchant Enrollment" };
  }

  return pageMeta[pathname] || { title: titleFromPath(pathname) };
};
